import styles from "./DriveInfo.module.css";
import { Row, Col } from "antd";

function DriveInfo({ icon, title, data, unit }: { icon: string; title: string; data: string; unit: string }) {
    return (
        <Row align={"middle"} className={styles.body}>
            <Col span={14}>
                <img className={styles.icon} src={icon} />
                <p className={styles.title}>{title}</p>
            </Col>
            <Col span={10}>
                <div className={styles.dataBody}>
                    <p className={styles.data}>{data}</p>
                    <p className={styles.unit}>{unit}</p>
                </div>
            </Col>
        </Row>
    );
}

export default DriveInfo;
